/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  JobRestService,
  JobSpecRestService,
  JobSpecTemplateRestService,
} from '@gh/builder-shared-data';
import { getRouteParam, getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { ID, PrintEntryPoint } from '@gh/common-shared-data';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { JobSpecDetails, jobSpecFromDto, JobSpecTemplateListItem, jobSpecToDto } from './job.model';

@Injectable()
export class JobSpecBusinessService implements InitViewService {
  constructor(private jobSpecTemplateRest: JobSpecTemplateRestService,
              private jobRest: JobRestService,
              private jobSpecRest: JobSpecRestService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    const jobId = getRouteParam(route, 'jobId');
    const specTemplateId = getRouteQueryParam(route, 'specTemplateId');
    const forDpp = getRouteQueryParam(route, 'forDpp');

    return {
      forDpp,
      jobSpec: this.get(jobId, specTemplateId, forDpp),
    };
  }

  findAllAsDataSource(query: FilteredDataQuery<string>): Observable<JobSpecTemplateListItem[]> {
    return this.jobSpecTemplateRest.findAllAsFinderDataSource({
      searchString: query.filter,
      showDeleted: false,
      isForRfq: false,
    }).select(query).pipe(map$(getSlicedData));
  }

  get(jobId: ID, specTemplateId?: ID, forDpp?: boolean): Observable<JobSpecDetails> {
    return this.jobSpecRest.get(jobId, { specTemplateId, forDpp }).pipe(map$(jobSpecFromDto));
  }

  save(jobId: ID, jobSpec: JobSpecDetails): Observable<JobSpecDetails> {
    return this.jobSpecRest.save(jobId, jobSpecToDto(jobSpec)).pipe(map$(jobSpecFromDto));
  }

  produce(jobId: ID, jobSpec: JobSpecDetails, entryPoint: PrintEntryPoint): Observable<JobSpecDetails> {
    return this.jobSpecRest.produce(jobId, jobSpecToDto(jobSpec), entryPoint).pipe(map$(jobSpecFromDto));
  }
}
